import Box from '@mui/material/Box'
import { FunctionComponent, useState } from 'react'
import CategoryLayout from 'components/Layout/Category'
import useEmotionStyles from 'hooks/useEmotionStyles'
import { useStores } from 'stores/utils/hooks/useStores'
import { trackInAmplitude } from 'utils/tracking/amplitude'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'

interface WrapperProps {
  children: React.ReactElement
  validator: (value: string) => boolean
  value: string | string[]
  disableDisclose?: boolean
  testId?: string
  path?: string
}

const styles = () => ({
  undisclosedBox: {
    display: 'none'
  }
})

const Wrapper: FunctionComponent<WrapperProps> = ({
  children,
  validator,
  value,
  disableDisclose,
  testId,
  path
}) => {
  const [isPathCompleted, setIsPathCompleted] = useState(false)
  const { undisclosedBox } = useEmotionStyles(styles)
  const {
    traversal: { removeErrorsForPath, getErrorsForPath }
  } = useStores()

  /* rendering a component progressively caused re-rendering due to wrappers that we have 
  to solve this we will render the components but hide them */

  /* to maintain nesting of text elements we return children directly for caption elements */
  const returnedElement =
    children.props.variant === 'caption' ? (
      children
    ) : (
      <Box data-testid={testId}>
        <CategoryLayout>{children}</CategoryLayout>
      </Box>
    )

  if (isPathCompleted || disableDisclose) {
    return returnedElement
  }

  const isValid = Array.isArray(value)
    ? value.every((singleValue) => validator(singleValue))
    : validator(value)

  if (isValid) {
    if (!isPathCompleted) {
      trackInAmplitude(AmplitudeEvent.ProgressiveDisclosurePathCompleted, {
        path: path
      })
    }
    setIsPathCompleted(true)
    return returnedElement
  }

  if (!isValid && path && getErrorsForPath(path).length > 0) {
    removeErrorsForPath(path)
  }
  return (
    <Box className={undisclosedBox} data-testid={testId}>
      <CategoryLayout>{children}</CategoryLayout>
    </Box>
  )
}

export default Wrapper
